module.exports = __webpack_public_path__ + "static/media/VectorAperture.10513aa1.svg";